import { Component, OnInit } from '@angular/core';
import { CommonService } from '../Services/common.service';
import { AuthService } from '../Services/auth.service';
import { Router } from "@angular/router";
import { AccountService } from '../Services/account.service';
import { CookieService } from '../Services/cookie';

@Component({
  selector: "app-select-service",
  templateUrl: "./select-service.component.html",
  standalone:false,
  styleUrls: ["./select-service.component.scss"],
})
export class SelectServiceComponent implements OnInit {
  ServiceType: string;
  serviceType: any;
  constructor(public auth: AuthService, private common: CommonService, private cookieService: CookieService, private _router: Router, public acc: AccountService) { }

  async ngOnInit(): Promise<any> {

    this.auth.accessToken = await this.common.Get("token");
    await this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data?.response?.code == 1) {

      }
      else {
        await this.common.hideLoading();

        this.common.ParseErrorAlert("", "", this._router, data);
      }
    })



  }

  activeTab: number = 0;

  changeTab(e) {

    this.activeTab = e;
    if (this.activeTab === 1) {
      this.ServiceType = "Conventional";
    } else if (this.activeTab === 2) {
      this.ServiceType = "Islamic";
    }
  }
  isValid(): boolean {

    // sirf jab activeTab == 0 ho tab disable karo
    return this.activeTab === 0;
  }

  next() {
    let body = {
      ServiceType: this.ServiceType
    }
    this.common.presentLoading();
    this.acc.UpdateServiceMode(body, this.auth.accessToken)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          console.log("UpdateServiceModesucess", data);
          await this.getService()
          await this.common.hideLoading();

        } else {
          await this.common.hideLoading();
          this.common.ParseErrorAlert("", "", this._router, data);
        }
      });
  }

  async getService() {
    // await this.CommonService.presentLoading();
    this.acc.GetServiceType({}, this.auth.accessToken)
      .then(async (data: any) => {
        if (data?.response?.code == 1) {
          console.log("GetServiceTypesucess", data);
          this.serviceType = data?.response?.content?.serviceType
          this.cookieService.set(
            "sTyp",
            this.serviceType,
            true
          );
          await this.common.hideLoading();
          if (this.serviceType === "None") {
            this._router.navigateByUrl("/SelectService");
          } else {
            this._router.navigateByUrl("/Dashboard");
          }
        } else {
          await this.common.hideLoading();
          this.common.ParseErrorAlert("", "", this._router, data);
        }
      });
  }



}
